/* Homebridge Precast — Contractor LP — Shopify scoped JS
   Targets #contractor-lp-root only. Uses data-clp-* attributes. */

(function () {
  'use strict';

  var root = document.getElementById('contractor-lp-root');
  if (!root) return;

  // --- FAQ ACCORDION ---
  var faqButtons = root.querySelectorAll('[data-clp-faq-toggle]');
  faqButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var answer = btn.nextElementSibling;

      // Close all others
      faqButtons.forEach(function (b) {
        if (b !== btn) {
          b.setAttribute('aria-expanded', 'false');
          if (b.nextElementSibling) b.nextElementSibling.hidden = true;
        }
      });

      btn.setAttribute('aria-expanded', String(!isOpen));
      if (answer) answer.hidden = isOpen;
    });
  });

  // --- SCROLL REVEAL ---
  if (!('IntersectionObserver' in window)) return;

  var targets = [
    '.clp-section-header', '.clp-product-card', '.clp-install-step',
    '.clp-faq-item', '.clp-stat', '.clp-spec-callout', '.clp-quote-block',
    '.clp-math-table-wrap', '.clp-problem-card'
  ];

  targets.forEach(function (sel) {
    root.querySelectorAll(sel).forEach(function (el, i) {
      el.classList.add('clp-reveal');
      if (i === 1) el.classList.add('clp-reveal-delay-1');
      if (i === 2) el.classList.add('clp-reveal-delay-2');
      if (i === 3) el.classList.add('clp-reveal-delay-3');
    });
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('clp-visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  root.querySelectorAll('.clp-reveal').forEach(function (el) {
    observer.observe(el);
  });

})();
